var map = {
	"./actions/add.svg": "f8d4",
	"./actions/back.svg": "9ce9",
	"./actions/duplicate.svg": "5b68",
	"./actions/edit.svg": "68bf",
	"./actions/print.svg": "61dc",
	"./actions/trash.svg": "7179",
	"./show_card.svg": "3228",
	"./tech_map.svg": "8d97"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95a3";